<!-- MAIN BUTTON -->
<button #menuTrigger="matMenuTrigger"
        type="button"
        [matMenuTriggerFor]="menuItem.menu"
        class="hierarchy-dropdown-dropdown-box"
        [disabled]="disabled"
        (menuOpened)="onDropdownToggle('open')"
        (menuClosed)="onDropdownToggle('close')"
        [attr.data-automation-id]="'bc-hierarchy-dropdown'">
  <svg-icon *ngIf="iconNameForDropdown" icon="{{ iconNameForDropdown }}" class="left-side-icon"></svg-icon>
  <span>{{ selectedItem?.text || placeholder }}</span>
  <svg-icon [attr.data-automation-id]="'bc-dropdown-arrow-icon'"
            icon="{{ !menuTrigger.menuOpen ? 'arrow-down' : 'arrow-up' }}"
            class="arrow-icon"></svg-icon>
</button>

<app-hierarchy-dropdown-sub-menu #menuItem
                                 (onSubItemSelected)="onItemSelect($event)"
                                 [items]="rootItems">
</app-hierarchy-dropdown-sub-menu>
